// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a4d62310","160":"2dc98c98","208":"71e3fc89","293":"33fefeb3","453":"8ab44547","516":"35a60e18","519":"54f097b2","917":"e2367a1b","946":"e01122fe"}[chunkId] + ".chunk.js";
};